import babelpolyfill from "babel-polyfill"
import Vue from "vue"
import App from "./App"
import ElementUI from "element-ui"
//import 'element-ui/lib/theme-default/index.css'
import "./assets/theme/theme-adminlte/index.css"
import VueRouter from "vue-router"
import store from "./vuex/store"
import Vuex from "vuex"
//import NProgress from 'nprogress'
//import 'nprogress/nprogress.css'
import routes from "./routes"
import "font-awesome/css/font-awesome.min.css"
import VueSession from "vue-session"
import { ServerTable, ClientTable, Event } from "vue-tables-2"

//auth0
import auth from "@/auth"

import Axios from "axios"

import numkeyboard from "vue-numkeyboard"
import "vue-numkeyboard/style.css"

import VueVisible from "vue-visible"

import LightTimeline from "vue-light-timeline"

import locale from "element-ui/lib/locale/lang/en"

import UserService from "@/api/user.service"

//Axios setup
Axios.defaults.baseURL = "https://variablevac.com:8443"

Vue.use(VueSession)
Vue.use(ElementUI, { locale })
Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(numkeyboard)
Vue.use(VueVisible)
Vue.use(LightTimeline)
Vue.use(auth)
Vue.use(ClientTable, {}, false, "bootstrap3", "default")

//NProgress.configure({ showSpinner: false });

Vue.prototype.$sysLock = true

const router = new VueRouter({
  mode: "history", //https://router.vuejs.org/api/#mode
  routes
})

router.beforeEach((to, from, next) => {
  //next();
  if (to.name == "Callback") {
    // check if "to"-route is "callback" and allow access

    next()
  } else if (router.app.$auth.isAuthenticated()) {
    console.log("authenticated")
    // if authenticated allow access
    //We check if the session has been created, and if it has not we add the user to the session
    if (!router.app.$session.exists()) {
      router.app.$session.start()
      UserService.getUser(router.app.$auth.user.email).then(response => {
        if (response.data.error == null) {
          router.app.$session.start()
          router.app.$session.set("User", response.data)
          next()
        } else {
          router.app.$auth.login()
        }
      })
    } else {
      //NProgress.start();
      next()
    }
  } else {
    // trigger auth0 login
    console.log("requesting login")
    router.app.$auth.login()
  }

  // //NProgress.start();
  // if (to.path == '/login') {
  //   sessionStorage.removeItem('user');
  // }
  // let user = JSON.parse(sessionStorage.getItem('user'));
  // if (!user && to.path != '/login') {
  //   next({ path: '/login' })
  // } else {
  //   next()
  // }
})

//router.afterEach(transition => {
//NProgress.done();
//});

new Vue({
  //el: '#app',
  //template: '<App/>',
  router,
  store,
  //components: { App }
  render: h => h(App)
}).$mount("#app")



// WEBPACK FOOTER //
// ./src/main.js